import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Cupom } from '../model/cupom.model';
import { Filtro } from '../model/filtro.model';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class CupomService extends BaseService{

    private headers: HttpHeaders;

    constructor(private http: HttpClient) { 
        super();
        this.headers = this.createAHeader();    
    }

    public count(filtro: Filtro): Promise<any> {
        return this.http.post(`${environment.apiUrl}cupom/count`, filtro, { headers: this.headers }).toPromise();
    }
    
    public encontrarPeloId(id: any): Promise<any> { 
        return this.http.get(`${environment.apiUrl}cupom/${id}`, { headers: this.headers }).toPromise();
    }
    
    public listar(filtro: Filtro): Promise<any> {
        return this.http.post(`${environment.apiUrl}cupom/list`, filtro, { headers: this.headers }).toPromise();
    }
    
    public deletar(id): Promise<any> {
        return this.http.delete(`${environment.apiUrl}cupom/${id}`, { headers: this.headers }).toPromise();
    }

    public editar(cupom): Promise<any> {
        return this.http.put(`${environment.apiUrl}cupom`, cupom, { headers: this.headers }).toPromise();
    }

    public criar(cupom: any): Promise<any> {
        return this.http.post(`${environment.apiUrl}cupom`, cupom, { headers: this.headers }).toPromise();
    }

    public baixa(id): Promise<any> {
        return this.http.get(`${environment.apiUrl}cupom/baixa/${id}`, { headers: this.headers }).toPromise();
    }

    public obterSaldoResidual(id): Promise<any> {
        return this.http.get(`${environment.apiUrl}cupom/saldoResidual/${id}`, { headers: this.headers }).toPromise();
    }

    public checarSePossuiCupomAberto(id): Promise<any> {
        return this.http.get(`${environment.apiUrl}cliente/cupomaberto/${id}`, { headers: this.headers }).toPromise();
    }

    public obterSaldoResidualCupom(id): Promise<any> {
        return this.http.get(`${environment.apiUrl}cupom/saldoCupom/${id}`, { headers: this.headers }).toPromise();
    }

}